import { type FC, useMemo } from 'react';
import { Link, ParagraphList } from '@direct-frontend/components';
import { SettingsIslandWithTitle } from '#shared/components/SettingsIslandWithTitle';
import { SettingsPageLayout } from '#shared/components/SettingsPageLayout';
import { PAGE_TITLE_SETTINGS_TEST_ORDER } from '#shared/lib/constants';
import { ordersRoute, productsRoute } from '#shared/lib/routes';
import { checkStoreType, STORE_TYPE_BITRIX, STORE_TYPE_LITE, STORE_TYPE_YCP } from '#shared/lib/storeInfo';
import { InfoBlock } from '#shared/ui/InfoBlock';

const texts = {
    lite: {
        info: 'Перед публикацией нужно проверить, что всё работает: оплата проходит, чек формируется, товар резервируется и передаётся в доставку.',
    },
    external: {
        info: 'Перед публикацией кнопки «Купить в 1 клик» нужно проверить, что всё работает: оплата проходит, чек формируется, товар резервируется и передаётся в доставку.',
    },
    internal: {
        info: 'Перед публикацией магазина нужно проверить, что всё работает: оплата проходит, чек формируется, товар резервируется и передаётся в доставку',
    },
};

export const SettingsTestOrder: FC = () => {
    const opensCheckout = checkStoreType([STORE_TYPE_LITE, STORE_TYPE_YCP, STORE_TYPE_BITRIX]);
    const infoText = checkStoreType([STORE_TYPE_LITE])
        ? texts.lite.info
        : texts[opensCheckout ? 'external' : 'internal'].info;

    const items = useMemo(
        () => [
            {
                content: (
                    <>
                        Откройте{' '}
                        <Link target="_blank" rel="noreferrer" href={productsRoute.route}>
                            раздел Товары.
                        </Link>
                    </>
                ),
            },
            {
                content: opensCheckout
                    ? 'Выберите товар в таблице и нажмите кнопку «Открыть чекаут». Вы попадёте на страницу оформления заказа — проверьте, что логотип отображается правильно, а ссылки на доставку, оплату и другие разделы работают.'
                    : 'Выберите товар в таблице и нажмите кнопку «Показать на сайте». Вы попадёте на страницу товара на сайте. Добавьте товар в корзину и нажмите «Перейти к оформлению».',
            },
            {
                content: 'Выберите способ доставки и оплатите заказ.',
            },
            {
                content: (
                    <>
                        Откройте{' '}
                        <Link target="_blank" rel="noreferrer" href={ordersRoute.route}>
                            раздел Заказы.
                        </Link>
                    </>
                ),
            },
            {
                content:
                    'После принятия заказа службой доставки его статус должен измениться на «Ожидает доставку». Это значит, что заказ считается успешно оформленным.',
            },
            {
                content: 'Теперь вы можете нажать на кнопку «Опубликовать».',
            },
            {
                content: 'Необязательно забирать заказ. Вы можете отменить его и вернуть оплату в любой момент.',
            },
        ],
        [opensCheckout]
    );

    return (
        <SettingsPageLayout title={PAGE_TITLE_SETTINGS_TEST_ORDER}>
            <InfoBlock color="message" type="icon">
                {infoText}
            </InfoBlock>
            <SettingsIslandWithTitle title="Как сделать тестовый заказ">
                <ParagraphList items={items} view="numbered" />
                <InfoBlock color="info" type="icon">
                    Если все настроено корректно, весь процесс займет считанные минуты
                </InfoBlock>
            </SettingsIslandWithTitle>
        </SettingsPageLayout>
    );
};
